<template>
  <div class="flex flex-column justify-between relative full-height">
    <div class="col-12">
      <div v-if="products.length" class="flex items-center flex-wrap mb2">
        <div class="col-12">
          <ProductOffer
            v-for="(product, index) in products"
            :key="index"
            :item="product"
            :selected-offer="selectedOffer"
            @toggle="growCollapsible"
            @offer-selected="selectOffer"
          />
        </div>
      </div>

      <div v-else>
        <h4 class="h4 mt1 mb0 center flex items-center">Aucun produit disponible pour cette session!</h4>
      </div>
    </div>
  </div>
</template>

<script>
import ProductOffer from '@/components/products/ProductOffer.vue';

export default {
  name: 'ProductCard',
  components: { ProductOffer },
  data () {
    return {
      workspace: this.$store.getters.workspace,
      cart: this.$store.state.cart,
      openedCollapsible: null,
      selectedOffer: null
    };
  },
  computed: {
    products () {
      return this.$store.state.products;
    }
  },
  methods: {
    growCollapsible (id) {
      // Close opened product
      if (this.openedCollapsible) {
        const element = document.querySelector(`#details-${this.openedCollapsible}`);
        element.style.height = '0px';
      }

      // Open if it's a different product
      if (this.openedCollapsible !== id) {
        const element = document.querySelector(`#details-${id}`);
        const content = document.querySelector(`#details-content-${id}`);
        element.style.height = `${element.offsetHeight + content.offsetHeight}px`;
        this.openedCollapsible = id;
      } else {
        this.openedCollapsible = null;
      }
    },
    selectOffer (value) {
      this.selectedOffer = value.id;
      this.$emit('offer-selected', value);
    }
  }
};
</script>

<style lang="scss">
</style>
